"use client";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaIndustry,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#0052A4] text-white">
      <div className="max-w-7xl mx-auto px-6 py-14">

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">

  {/* Company */}
  <div className="flex flex-col h-full">
    <h3 className="text-2xl font-bold">AirEast HVAC</h3>

    <p className="mt-4 text-sm text-white/80 leading-7">
      Providing reliable HVAC solutions with quality products,
      professional service, and customer satisfaction across Pakistan.
    </p>
  </div>

  {/* Quick Links */}
  <div className="flex flex-col h-full">
    <h4 className="text-lg font-semibold mb-4">Quick Links</h4>

    <ul className="space-y-3 text-white/80 text-sm">
      <li><a href="#hero" className="hover:text-white transition">Home</a></li>
      <li><a href="#about" className="hover:text-white transition">About</a></li>
      <li><a href="#products" className="hover:text-white transition">Products</a></li>
      <li><a href="#contact" className="hover:text-white transition">Contact</a></li>
    </ul>
  </div>

  {/* Contact */}
  <div className="flex flex-col h-full">
    <h4 className="text-lg font-semibold mb-5">Contact</h4>

    <div className="space-y-5 text-sm text-white/80">

      <div className="flex items-start gap-3">
        <FaPhoneAlt className="text-lg text-white mt-1 flex-shrink-0" />
        <div>
          <p>+92 321 4435 667</p>
          <p>+92 316 4928 092</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <FaEnvelope className="text-lg text-white flex-shrink-0" />
        <p>powermotoract@hotmail.com</p>
      </div>

      <div className="flex items-start gap-3">
        <FaMapMarkerAlt className="text-lg text-white mt-1 flex-shrink-0" />
        <div>
          <h5 className="font-semibold text-white mb-1">Main Office</h5>
          <p>
            18 km GT Road, ½ km Main Sootar Mill Bazar,
            Manawan, Lahore, Pakistan.
          </p>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <FaIndustry className="text-lg text-white mt-1 flex-shrink-0" />
        <div>
          <h5 className="font-semibold text-white mb-1">Factory</h5>
          <p>
            Main BRB Road, Near AR Farm,
            Rehmanpura, Jallo, Lahore, Pakistan.
          </p>
        </div>
      </div>

    </div>
  </div>

</div>
        <div className="border-t border-white/20 mt-10 pt-5 text-center text-sm text-white/70">
          © {new Date().getFullYear()} AirEast HVAC. All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}